import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function StarHalf(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2a.544.544 0 00-.53.392L9.385 9.177H2.555c-.53 0-.757.676-.336 1l5.548 4.257-2.105 6.842c-.16.518.437.936.866.607l5.472-4.2 5.472 4.2c.429.33 1.025-.089.866-.607l-2.105-6.842 5.548-4.258c.421-.323.194-.999-.336-.999h-6.829L12.53 2.392A.544.544 0 0012 2zm0 14.423l4.973 3.816-1.9-6.175 5.065-3.887h-6.26L12 4.073v12.35z",
    clipRule: "evenodd"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(StarHalf);
export default ForwardRef;